module.exports = __webpack_public_path__ + "static/media/OurEye-Banner-Transparent-Light.2528c0bc.png";